// ************************************************************ PERSONAL IMPORTS
import { modelDbServiceWorker } from '@data/datasource/local/model';
import { IServiceWorker } from '@shared/interface/model.interface';
import { logger } from '@shared/lib/logger/logger-manager';
// import { process } from '@shared/resources/swenv'

// ************************************************************ DEXIE IMPORTS
import { Dexie } from 'dexie';

// ************************************************************ DATABASES NAMES
const dbServiceWorkerName = process.env.FRONTEND.databasesName.dbServiceWorker;

export class ClassDbServiceWorker extends Dexie {
  state!: Dexie.Table<IServiceWorker>;

  constructor() {
    super(dbServiceWorkerName);

    // Versionning
    modelDbServiceWorker.forEach((currentModel) => {
      this.version(currentModel.version)
        .stores(currentModel.schema)
        .upgrade((trans) => {
          if (currentModel.upgradeFn) {
            currentModel.upgradeFn(trans);
          }
        });
    });

    // The following lines are needed for it to work across typescipt using babel-preset-typescript:
    this.state = this.table('state');

    // Dexie events
    this.on('blocked', function () {
      logger?.log('[Dexie] Database dbServiceWorker BLOQUED');
    });

    this.on('close', function () {
      logger?.log('[Dexie] Database dbServiceWorker CLOSED');
    });
  }

  /**
   * db recreate (needed if model has changed in a new version of the application)
   */
  deleteDbServiceWorker() {
    logger?.log('start deleting dbServiceWorker');
    this.delete()
      .then(() => {
        logger?.log('dbServiceWorker deleted');
      })
      .catch((err) => {
        logger?.error('Could not delete database dbServiceWorker - err :', err);
      });
  }
}

export const dbServiceWorker = new ClassDbServiceWorker();
